module.exports = __webpack_public_path__ + "img/Eastbourne-College-Sports.0d71b4d7.jpg";